<script>
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import vue2Dropzone from "vue2-dropzone";
import Swal from "sweetalert2";

/**
 * Add-product component
 */
export default {
  page: {
    title: "Nueva poliza auto",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    vueDropzone: vue2Dropzone,
    DatePicker,
    Multiselect,
    Layout,
    PageHeader,
  },
  beforeCreate() {
    console.log(this.$route.params.rfc);
    firebase
      .firestore()
      .collection("Usuarios")
      .where("rfc", "==", this.$route.params.rfc.toUpperCase())
      .get()
      .then((querySnapshot) => {
        console.log(querySnapshot.size);
        if (querySnapshot.size > 0) {
          querySnapshot.forEach((documentSnapshot) => {
            this.dataUsuario = documentSnapshot.data();
            this.title =
              "Registro de nueva poliza de " + this.dataUsuario.nombre;
            console.log(this.dataUsuario);
          });
        } else {
          this.title = "Usuario no encotrado";
        }
      });
  },
  methods: {
    GuardarPolizaAuto() {
      this.pdf = null;
      var n = this.file.search("base64,");
      var base64 = this.file.slice(n + 7);
      const storageRef = firebase
        .storage()
        .ref("polizaAuto/" + this.numPoliza + ".pdf")
        .putString(base64, "base64");
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            this.pdf = url;
            firebase
              .firestore()
              .collection("PolizaAutos")
              .doc(this.numPoliza)
              .set({
                rfc: this.dataUsuario.rfc,
                numPoliza: this.numPoliza,
                compania: this.compania,
                estatus: this.estatus,
                descripCancelacion: this.descripCancelacion,
                modelo: this.modelo,
                descripcionAuto: this.descripcionAuto,
                formaPago: this.formaPago,
                numSerie: this.numSerie,
                vDesde: moment(this.vDesde, "DD-MM-YYYY").format("DD-MM-YYYY"),
                vHasta: moment(this.vHasta, "DD-MM-YYYY").format("DD-MM-YYYY"),
                cobertura: this.cobertura,
                file_url: url,
              })
              .then(() => {
                location.href = "/usuarios/nuevaPoliza/" + this.dataUsuario.rfc;
              })
              .catch((error) => {
                alert(error);
              });
          });
          Swal.fire({
            icon: "success",
            title: "Tu registro ha sido guardado",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      );
    },

    deletePolizaAuto(numPoliza) {
      Swal.fire({
        title: "¿Estas seguro de eliminar esta poliza ",
        text: "Esta poliza se eliminiara permanentemente.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Borrar",
      }).then((result) => {
        if (result.value) {
          Swal.fire(
            "Eliminado",
            "Su poliza ha sido eliminado con exito",
            "success"
          );
          firebase
            .firestore()
            .collection("PolizaAutos")
            .doc(numPoliza.toString())
            .delete()
            .then(() => {
              location.href = "/usuarios/nuevaPoliza/" + this.dataUsuario.rfc;
            })
            .catch((error) => {
              alert("Error removing document: ", error);
            });
        }
      });
    },

    agregarAsegurados() {
      this.dataAsegurados.push({
        nombre: this.aseguradosGM.nombre,
        fechaNacimiento: moment(
          this.aseguradosGM.fechaNacimiento,
          "DD-MM-YYYY"
        ).format("DD-MM-YYYY"),
        fechaAntiguedad: moment(
          this.aseguradosGM.fechaAntiguedad,
          "DD-MM-YYYY"
        ).format("DD-MM-YYYY"),
        parentesco: this.aseguradosGM.parentesco,
      });
      this.aseguradosGM = {
        nombre: "",
        parentesco: "",
        fechaNacimiento: "",
      };
      console.log(this.dataAsegurados);
    },
    GuardarPolizaGM() {
      this.pdf = null;
      var n = this.file.search("base64,");
      var base64 = this.file.slice(n + 7);
      const storageRef = firebase
        .storage()
        .ref("polizaGM/" + this.certificadoGM + ".pdf")
        .putString(base64, "base64");
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            this.pdf = url;
            firebase
              .firestore()
              .collection("PolizaGM")
              .doc(this.certificadoGM)
              .set({
                rfc: this.dataUsuario.rfc,
                dataAsegurados: this.dataAsegurados,
                numPolizaGM: this.numPolizaGM,
                compania: this.compania,
                certificadoGM: this.certificadoGM,
                sumaGM: this.sumaGM,
                deducible: this.deducible,
                coaseguro: this.coaseguro,
                numSerie: this.numSerie,
                vvDesde: moment(this.vDesde, "DD-MM-YYYY").format("DD-MM-YYYY"),
                vHasta: moment(this.vHasta, "DD-MM-YYYY").format("DD-MM-YYYY"),
                cobertura: this.cobertura,
                file_url: url,
              })
              .then(() => {
                location.href = "/usuarios/nuevaPoliza/" + this.dataUsuario.rfc;
              })
              .catch((error) => {
                alert(error);
              });
          });
          Swal.fire({
            icon: "success",
            title: "Tu registro ha sido guardado",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      );
    },
    Estatus() {
      firebase
        .firestore()
        .collection("PolizaAuto")
        .doc(this.numPoliza)
        .set({
          estatus: this.estatus,
          descripCancelacion: this.descripCancelacion,
        })
        .then(() => {
          location.href = "/usuarios/nuevaPoliza/" + this.dataUsuario.rfc;
        })
        .catch((error) => {
          alert(error);
        });
      Swal.fire({
        icon: "success",
        title: "Tu registro ha sido guardado",
        showConfirmButton: false,
        timer: 1500,
      });
      this.modalEstatus = false;
    },
    deletePolizaGM(certificadoGM) {
      Swal.fire({
        title: "¿Estas seguro de eliminar esta poliza?",
        text: "Esta poliza se eliminiara permanentemente.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Borrar",
      }).then((result) => {
        if (result.value) {
          Swal.fire(
            "Eliminado",
            "Su poliza ha sido eliminado con exito",
            "success"
          );
          firebase
            .firestore()
            .collection("PolizaGM")
            .doc(certificadoGM.toString())
            .delete()
            .then(() => {
              location.href = "/usuarios/nuevaPoliza/" + this.dataUsuario.rfc;
            })
            .catch((error) => {
              alert("Error removing document: ", error);
            });
        }
      });
    },
    GuardarPolizaVida() {
      this.pdf = null;
      var n = this.file.search("base64,");
      var base64 = this.file.slice(n + 7);
      const storageRef = firebase
        .storage()
        .ref("polizaVida/" + this.certificadoVida + ".pdf")
        .putString(base64, "base64");
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            this.pdf = url;
            firebase
              .firestore()
              .collection("PolizaVida")
              .doc(this.certificadoVida)
              .set({
                rfc: this.dataUsuario.rfc,
                numPolizaVida: this.numPolizaVida,
                compania: this.compania,
                certificadoVida: this.certificadoVida,
                sumaVida: this.sumaVida,
                vDesde: moment(this.vDesde, "DD-MM-YYYY").format("DD-MM-YYYY"),
                vHasta: moment(this.vHasta, "DD-MM-YYYY").format("DD-MM-YYYY"),
                file_url: url,
              })
              .then(() => {
                location.href = "/usuarios/nuevaPoliza/" + this.dataUsuario.rfc;
              })
              .catch((error) => {
                alert(error);
              });
          });

          Swal.fire({
            icon: "success",
            title: "Tu registro ha sido guardado",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      );
    },
    deletePolizaVida(certificadoVida) {
      Swal.fire({
        title: "¿Estas seguro de eliminar esta poliza?",
        text: "Esta poliza se eliminiara permanentemente.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Borrar",
      }).then((result) => {
        if (result.value) {
          Swal.fire(
            "Eliminado",
            "Su poliza ha sido eliminado con exito",
            "success"
          );
          firebase
            .firestore()
            .collection("PolizaVida")
            .doc(certificadoVida.toString())
            .delete()
            .then(() => {
              location.href = "/usuarios/nuevaPoliza/" + this.dataUsuario.rfc;
            })
            .catch((error) => {
              alert("Error removing document: ", error);
            });
        }
      });
    },
    previewFile(file, response) {
      this.file = response.files.file;
    },
    onWhatsapp(rfc) {
      console.log("RFC", rfc);
      this.$router.push({
        name: "Whatsapp",
        params: { rfc: rfc },
      });
    },
  },
  mounted() {
    firebase
      .firestore()
      .collection("PolizaAutos")
      .where("rfc", "==", this.$route.params.rfc.toUpperCase())
      .get()
      .then((querySnapshot) => {
        var array = [];
        querySnapshot.forEach((documentSnapshot) => {
          array.push({
            numPoliza: documentSnapshot.data().numPoliza,
            compania: documentSnapshot.data().compania,
            descripcionAuto: documentSnapshot.data().descripcionAuto,
            modelo: documentSnapshot.data().modelo,
            vDesde: moment(documentSnapshot.data().vDesde, "DD-MM-YYYY").format(
              "DD-MM-YYYY"
            ),
            vHasta: moment(documentSnapshot.data().vHasta, "DD-MM-YYYY").format(
              "DD-MM-YYYY"
            ),
          });
        });
        this.dataPolizaAuto = array;
      });
    firebase
      .firestore()
      .collection("PolizaGM")
      .where("rfc", "==", this.$route.params.rfc.toUpperCase())
      .get()
      .then((querySnapshot) => {
        var array = [];
        querySnapshot.forEach((documentSnapshot) => {
          array.push({
            numPolizaGM: documentSnapshot.data().numPolizaGM,
            certificadoGM: documentSnapshot.data().certificadoGM,
            compania: documentSnapshot.data().compania,
            vDesde: moment(documentSnapshot.data().vDesde, "DD-MM-YYYY").format(
              "DD-MM-YYYY"
            ),
            vHasta: moment(documentSnapshot.data().vHasta, "DD-MM-YYYY").format(
              "DD-MM-YYYY"
            ),
          });
        });
        this.dataPolizaGM = array;
        console.log(array);
      });
    firebase
      .firestore()
      .collection("PolizaVida")
      .where("rfc", "==", this.$route.params.rfc.toUpperCase())
      .get()
      .then((querySnapshot) => {
        var array = [];
        querySnapshot.forEach((documentSnapshot) => {
          array.push({
            numPolizaVida: documentSnapshot.data().numPolizaVida,
            certificadoVida: documentSnapshot.data().certificadoVida,
            compania: documentSnapshot.data().compania,
            vDesde: moment(documentSnapshot.data().vDesde, "x").format(
              "DD-MM-YYYY"
            ),
            vHasta: moment(documentSnapshot.data().vHasta, "x").format(
              "DD-MM-YYYY"
            ),
          });
        });
        this.dataPolizaVida = array;
      });
    firebase
      .firestore()
      .collection("ImgCompania")
      .get()
      .then((querySnapshot) => {
        var array = [];
        querySnapshot.forEach((documentSnapshot) => {
          array.push({
            nombreCompania: documentSnapshot.data().nombreCompania,
            numTelefonoAuto: documentSnapshot.data().numTelefonoAuto,
            numTelefonoGM: documentSnapshot.data().numTelefonoGM,
          });
        });

        this.dataCompaniaList = array;
        this.dataCompania = array;
      });
  },

  data() {
    return {
      title: "Registro de nueva poliza",
      options: [],
      items: [
        {
          text: "Registro",
          href: "/",
        },
        {
          text: "Poliza",
          active: true,
        },
      ],
      rfc: null,
      dataUsuario: {
        nombre: "",
      },
      modalEstatus: false,
      descripCancelacion: null,
      dataPolizaAuto: [],
      dataEstatus: {
        descripCancelacion: "",
        estatus: "",
      },
      dataCompania: [],
      dataCompaniaList: [],
      dataPolizaVida: [],
      dataPolizaGM: [],
      aseguradosGM: {
        nombre: "",
        parentesco: "",
        fechaNacimiento: "",
        fechaAntiguedad: "",
      },
      file: null,
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 150,
        maxFilesize: 3.5,
        headers: { "My-Awesome-Header": "header value" },
      },
      dataAsegurados: [],
      numPoliza: null,
      estatus: "activo",
      compania: null,
      parentescoOptionsGM: [
        "TITULAR",
        "CONYUGE",
        "HIJO",
        "HIJA",
        "MADRE",
        "PADRE",
        "HERMANO",
        "HERMANA",
        "SOBRINO",
        "SOBRINA",
        "NIETO",
        "NIETA",
        "ABUELO",
        "ABUELA",
      ],
      companiaOptions: ["Afirme", "Atlas", "Axa"],
      estatusOptions: ["VIGENTE", "CANCELADO"],
      modelo: null,
      descripcionAuto: null,
      numSerie: null,
      vDesde: null,
      vHasta: null,
      cobertura: null,
      numTelefonoAuto: null,
      numTelefonoGM: null,
      coberturaOptions: ["AMPLIA", "BASICA", "LIMITADA", "PLATINUM"],
      formaPago: null,
      formaPagoOptions: [
        "SEMANAL",
        "QUINCENAL",
        "MENSUAL",
        "TRIMESTRAL",
        "SEMESTRAL",
        "ANUAL",
      ],
      certificadoGM: null,
      coaseguro: null,
      deducible: null,
      numPolizaGM: null,
      sumaGM: null,
      numPolizaVida: null,
      certificadoVida: null,
      companiaVida: null,
      companiaOptionsVida: ["Afirme", "Atlas", "Axa"],
      sumaVida: null,
    };
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="checkout-tabs">
      <b-tabs pills vertical nav-class="p-0" nav-wrapper-class="col-lg-2 w-100">
        <b-tab active>
          <template v-slot:title>
            <i class="bx bxs-car d-block check-nav-icon mt-4 mb-2"></i>
            <p class="font-weight-bold mb-4">Autos</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Captura de poliza auto</h4>
                <div class="row">
                  <div class="col-12">
                    <div class="card">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-sm-6">
                            <h4 class="card-title">Datos Vehiculo</h4>
                            <div class="form-group">
                              <div class="row">
                                <div class="col-sm-6">
                                  <label>Numero Poliza</label>
                                  <input
                                    v-model="numPoliza"
                                    type="text"
                                    class="form-control"
                                  />
                                </div>
                                <div class="col-sm-6">
                                  <label>Compañia</label>
                                  <multiselect
                                    v-model="compania"
                                    label="nombreCompania"
                                    track-by="nombreCompania"
                                    :show-labels="false"
                                    :options="dataCompania"
                                  ></multiselect>
                                </div>
                              </div>
                            </div>
                            <div class="form-group">
                              <div class="row">
                                <div class="col-sm-12">
                                  <label class="control-label">Modelo</label>
                                  <input
                                    type="text"
                                    v-model="modelo"
                                    class="form-control"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="form-group">
                              <div class="row">
                                <div class="col-sm-12">
                                  <label class="control-label"
                                    >Descripción del vehiculo</label
                                  >
                                  <input
                                    type="text"
                                    v-model="descripcionAuto"
                                    class="form-control"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="form-group">
                              <div class="row">
                                <div class="col-sm-8">
                                  <label class="control-label"
                                    >Numero serie</label
                                  >
                                  <input
                                    type="text"
                                    v-model="numSerie"
                                    class="form-control"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="form-group">
                              <div class="row">
                                <div class="col-sm-6">
                                  <label class="control-label">Cobertura</label>
                                  <multiselect
                                    v-model="cobertura"
                                    :show-labels="false"
                                    :options="coberturaOptions"
                                  ></multiselect>
                                </div>
                                <div class="col-sm-6">
                                  <label class="control-label"
                                    >Forma de pago</label
                                  >
                                  <multiselect
                                    v-model="formaPago"
                                    :show-labels="false"
                                    :options="formaPagoOptions"
                                  ></multiselect>
                                </div>
                              </div>
                            </div>
                            <div class="form-group">
                              <label>Vigencia</label>
                              <div class="row">
                                <div class="col-sm-6">
                                  <label>Desde:</label>
                                  <date-picker
                                    v-model="vDesde"
                                    :first-day-of-week="1"
                                    lang="en"
                                    confirm
                                  ></date-picker>
                                </div>
                                <div class="col-sm-6">
                                  <label>Hasta:</label>
                                  <date-picker
                                    v-model="vHasta"
                                    :first-day-of-week="1"
                                    lang="en"
                                    confirm
                                  ></date-picker>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <div class="col-sm-12">
                                <div class="form-group">
                                  <label for="productdesc">Subir poliza</label>
                                  <vue-dropzone
                                    id="dropzone"
                                    ref="myVueDropzone"
                                    :use-custom-slot="true"
                                    :options="dropzoneOptions"
                                    @vdropzone-success="previewFile"
                                  >
                                    <div class="dropzone-custom-content">
                                      <div class="mb-1">
                                        <i
                                          class="display-4 text-muted bx bxs-cloud-upload"
                                        ></i>
                                      </div>
                                      <h4>
                                        Arrastre el documento aquí o haga clic
                                        para cargar.
                                      </h4>
                                    </div>
                                  </vue-dropzone>
                                </div>
                              </div>
                              <div class="col-sm-12">
                                <div class="text-sm-right">
                                  <button
                                    class="btn btn-success"
                                    @click="GuardarPolizaAuto"
                                  >
                                    <i class="mdi mdi-account-plus mr-1"></i>
                                    Guardar
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Total de polizas</h4>

                <div class="row">
                  <div class="col-12">
                    <div class="card">
                      <div class="card-body">
                        <div class="row">
                          <div class="table-responsive">
                            <table
                              class="table table-centered mb-0 table-nowrap"
                            >
                              <thead class="thead-light">
                                <tr>
                                  <th>Numero poliza</th>
                                  <th>Descripcion</th>
                                  <th>Compañia</th>
                                  <th>Vigencia</th>
                                  <th>Envio de Poliza</th>
                                  <th>Cambiar estatus</th>
                                  <th>Eliminar</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="data in dataPolizaAuto"
                                  :key="data.numPoliza"
                                >
                                  <td>{{ data.numPoliza }}</td>
                                  <td>{{ data.descripcionAuto }}</td>
                                  <td>{{ data.compania.nombreCompania }}</td>
                                  <td>{{ data.vHasta }}</td>
                                  <td>
                                    <button
                                      class="btn btn-primary"
                                      @click="onIrWhatsapp(data.rfc)"
                                    >
                                      <i class="mdi mdi-account-plus mr-1"></i>
                                      Entrar
                                    </button>
                                  </td>
                                  <td>
                                    <button
                                      v-if="dataPolizaAuto"
                                      type="button"
                                      class="btn btn-warning"
                                      @click="
                                        modalEstatus = true;
                                        dataEstatus = data;
                                      "
                                    >
                                      Cancelar
                                    </button>
                                  </td>
                                  <td>
                                    <button
                                      v-if="dataPolizaAuto"
                                      type="button"
                                      class="btn btn-danger"
                                      @click="deletePolizaAuto(data.numPoliza)"
                                    >
                                      Eliminar
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>
        <b-tab active>
          <template v-slot:title>
            <i class="bx bx-plus-medical d-block check-nav-icon mt-4 mb-2"></i>
            <p class="font-weight-bold mb-4">Gastos medicos</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Captura de poliza de Gastos Medicos</h4>

                <div class="row">
                  <div class="col-12">
                    <div class="card">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-sm-6">
                            <h4 class="card-title">Registrar asegurados</h4>
                            <div class="form-group">
                              <div class="row">
                                <div class="col-sm-12">
                                  <label>Nombre</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="aseguradosGM.nombre"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="form-group">
                              <div class="row">
                                <div class="col-sm-6">
                                  <label class="control-label"
                                    >Parentesco</label
                                  >
                                  <multiselect
                                    v-model="aseguradosGM.parentesco"
                                    :show-labels="false"
                                    :options="parentescoOptionsGM"
                                  ></multiselect>
                                </div>
                                <div class="col-sm-6">
                                  <label class="control-label"
                                    >Fecha Nacimiento</label
                                  >
                                  <date-picker
                                    v-model="aseguradosGM.fechaNacimiento"
                                    :first-day-of-week="1"
                                    lang="en"
                                    confirm
                                  ></date-picker>
                                </div>
                              </div>
                            </div>
                            <div class="form-group">
                              <div class="row">
                                <div class="col-sm-6">
                                  <label class="control-label"
                                    >Fecha Antigüedad</label
                                  >
                                  <date-picker
                                    v-model="aseguradosGM.fechaAntiguedad"
                                    :first-day-of-week="1"
                                    lang="en"
                                    confirm
                                  ></date-picker>
                                </div>
                                <div class="col-sm-6">
                                  <div class="text-sm-right">
                                    <button
                                      class="btn btn-success"
                                      @click="agregarAsegurados"
                                    >
                                      <i class="mdi mdi-account-plus mr-1"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="table-responsive">
                              <table
                                class="table table-centered mb-0 table-nowrap"
                              >
                                <thead class="thead-light">
                                  <tr>
                                    <th>Nombre</th>
                                    <th>Parentesco</th>
                                    <th>Fecha Nacimiento</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="data in dataAsegurados"
                                    :key="data.nombre"
                                  >
                                    <td>{{ data.nombre }}</td>
                                    <td>{{ data.parentesco }}</td>
                                    <td>{{ data.fechaNacimiento }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div
                              class="form-group"
                              v-if="dataAsegurados.length > 0"
                            >
                              <div class="col-sm-12">
                                <h4 class="card-title">
                                  Registrar datos de la poliza
                                </h4>
                                <div class="form-group">
                                  <div class="row">
                                    <div class="col-sm-4">
                                      <label class="control-label"
                                        >Certificado</label
                                      >
                                      <input
                                        v-model="certificadoGM"
                                        type="text"
                                        class="form-control"
                                      />
                                    </div>
                                    <div class="col-sm-4">
                                      <label class="control-label"
                                        >Numero poliza</label
                                      >
                                      <input
                                        v-model="numPolizaGM"
                                        type="text"
                                        class="form-control"
                                      />
                                    </div>
                                    <div class="col-sm-4">
                                      <label class="control-label"
                                        >Compañia</label
                                      >
                                      <multiselect
                                        v-model="compania"
                                        label="nombreCompania"
                                        track-by="nombreCompania"
                                        :show-labels="false"
                                        :options="dataCompania"
                                      ></multiselect>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group">
                                  <div class="row">
                                    <div class="col-sm-4">
                                      <label class="control-label">SUMA</label>
                                      <input
                                        v-model="sumaGM"
                                        type="text"
                                        class="form-control"
                                      />
                                    </div>
                                    <div class="col-sm-4">
                                      <label class="control-label"
                                        >Deducible</label
                                      >
                                      <input
                                        v-model="deducible"
                                        type="text"
                                        class="form-control"
                                      />
                                    </div>
                                    <div class="col-sm-4">
                                      <label class="control-label"
                                        >Coaseguro</label
                                      >
                                      <input
                                        v-model="coaseguro"
                                        type="text"
                                        class="form-control"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group">
                                  <div class="row">
                                    <div class="col-sm-6">
                                      <label class="control-label">Desde</label>
                                      <date-picker
                                        v-model="vDesde"
                                        :first-day-of-week="1"
                                        lang="en"
                                        confirm
                                      ></date-picker>
                                    </div>
                                    <div class="col-sm-6">
                                      <label class="control-label">Hasta</label>
                                      <date-picker
                                        v-model="vHasta"
                                        :first-day-of-week="1"
                                        lang="en"
                                        confirm
                                      ></date-picker>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group">
                                  <label for="productdesc">Subir poliza</label>
                                  <vue-dropzone
                                    id="dropzone"
                                    ref="myVueDropzone"
                                    :use-custom-slot="true"
                                    :options="dropzoneOptions"
                                    @vdropzone-success="previewFile"
                                  >
                                    <div class="dropzone-custom-content">
                                      <div class="mb-1">
                                        <i
                                          class="display-4 text-muted bx bxs-cloud-upload"
                                        ></i>
                                      </div>
                                      <h4>
                                        Arrastre el documento aquí o haga clic
                                        para cargar.
                                      </h4>
                                    </div>
                                  </vue-dropzone>
                                </div>
                              </div>

                              <div class="col-sm-12">
                                <div class="text-sm-right">
                                  <button
                                    class="btn btn-success"
                                    @click="GuardarPolizaGM"
                                  >
                                    <i class="mdi mdi-account-plus mr-1"></i>
                                    Guardar
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Poliza Totales</h4>

                <div class="row">
                  <div class="col-12">
                    <div class="card">
                      <div class="card-body">
                        <div class="row">
                          <div class="table-responsive">
                            <table
                              class="table table-centered mb-0 table-nowrap"
                            >
                              <thead class="thead-light">
                                <tr>
                                  <th>Numero Poliza</th>
                                  <th>Certificado</th>
                                  <th>Compañia</th>
                                  <th>Vigencia</th>
                                  <th>Envio de Poliza</th>
                                  <th>Cambiar estatus</th>
                                  <th>Eliminar</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="data in dataPolizaGM"
                                  :key="data.numPolizaGM"
                                >
                                  <td>{{ data.numPolizaGM }}</td>
                                  <td>{{ data.certificadoGM }}</td>
                                  <td>{{ data.compania.nombreCompania }}</td>
                                  <td>{{ data.vHasta }}</td>
                                  <td>
                                    <router-link
                                      to="/whatsapp/index"
                                      class="btn btn-success"
                                    >
                                      <i class="mdi mdi-whatsapp mr-1"></i>
                                    </router-link>
                                  </td>
                                  <td>
                                    <button
                                      v-if="dataPolizaGM"
                                      type="button"
                                      class="btn btn-warning"
                                      @click="
                                        deletePolizaGM(data.certificadoGM)
                                      "
                                    >
                                      Cancelar
                                    </button>
                                  </td>
                                  <td>
                                    <button
                                      v-if="dataPolizaGM"
                                      type="button"
                                      class="btn btn-danger"
                                      @click="
                                        deletePolizaGM(data.certificadoGM)
                                      "
                                    >
                                      Eliminar
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>

        <b-tab active>
          <template v-slot:title>
            <i class="bx bx-body d-block check-nav-icon mt-4 mb-2"></i>
            <p class="font-weight-bold mb-4">Vida</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Captura de poliza de Vida</h4>
                <div class="row">
                  <div class="col-12">
                    <div class="card">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-sm-6">
                            <h4 class="card-title">Registrar asegurado</h4>
                            <div class="form-group">
                              <div class="row">
                                <div class="col-sm-6">
                                  <label class="control-label"
                                    >Numero Poliza</label
                                  >
                                  <input
                                    v-model="numPolizaVida"
                                    type="text"
                                    class="form-control"
                                  />
                                </div>
                                <div class="col-sm-6">
                                  <label class="control-label"
                                    >Numero Certificado</label
                                  >
                                  <input
                                    v-model="certificadoVida"
                                    type="text"
                                    class="form-control"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="form-group">
                              <div class="row">
                                <div class="col-sm-6">
                                  <label class="control-label">Compañia</label>
                                  <multiselect
                                    v-model="compania"
                                    label="nombreCompania"
                                    track-by="nombreCompania"
                                    :show-labels="false"
                                    :options="dataCompania"
                                  ></multiselect>
                                </div>
                                <div class="col-sm-6">
                                  <label class="control-label">Suma</label>
                                  <input
                                    v-model="sumaVida"
                                    type="text"
                                    class="form-control"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="form-group">
                              <div class="row">
                                <div class="col-sm-6">
                                  <label class="control-label">Desde</label>
                                  <date-picker
                                    v-model="vDesde"
                                    :first-day-of-week="1"
                                    lang="en"
                                    confirm
                                  ></date-picker>
                                </div>
                                <div class="col-sm-6">
                                  <label class="control-label">Hasta</label>
                                  <date-picker
                                    v-model="vHasta"
                                    :first-day-of-week="1"
                                    lang="en"
                                    confirm
                                  ></date-picker>
                                </div>
                              </div>
                            </div>

                            <div class="table-responsive"></div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <div class="col-sm-12">
                                <h4 class="card-title">Subir poliza</h4>

                                <div class="form-group">
                                  <vue-dropzone
                                    id="dropzone"
                                    ref="myVueDropzone"
                                    :use-custom-slot="true"
                                    :options="dropzoneOptions"
                                    @vdropzone-success="previewFile"
                                  >
                                    <div class="dropzone-custom-content">
                                      <div class="mb-1">
                                        <i
                                          class="display-4 text-muted bx bxs-cloud-upload"
                                        ></i>
                                      </div>
                                      <h4>
                                        Arrastre el documento aquí o haga clic
                                        para cargar.
                                      </h4>
                                    </div>
                                  </vue-dropzone>
                                </div>
                              </div>

                              <div class="col-sm-12">
                                <div class="text-sm-right">
                                  <button
                                    class="btn btn-success"
                                    @click="GuardarPolizaVida"
                                  >
                                    <i class="mdi mdi-account-plus mr-1"></i>
                                    Guardar
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Poliza Totales</h4>

                <div class="row">
                  <div class="col-12">
                    <div class="card">
                      <div class="card-body">
                        <div class="row">
                          <div class="table-responsive">
                            <table
                              class="table table-centered mb-0 table-nowrap"
                            >
                              <thead class="thead-light">
                                <tr>
                                  <th>Numero Poliza</th>
                                  <th>Certificado</th>
                                  <th>Compañia</th>
                                  <th>Vigencia</th>
                                  <th>Envio de Poliza</th>
                                  <th>Cambiar estatus</th>
                                  <th>Eliminar</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="data in dataPolizaVida"
                                  :key="data.certificadoVida"
                                >
                                  <td>{{ data.numPolizaVida }}</td>
                                  <td>{{ data.certificadoVida }}</td>
                                  <td>{{ data.compania.nombreCompania }}</td>
                                  <td>{{ data.vHasta }}</td>
                                  <td>
                                    <button
                                      class="btn btn-primary"
                                      @click="onWhatsapp(data.rfc)"
                                    >
                                      <i class="mdi mdi-account-plus mr-1"></i>
                                      Entrar
                                    </button>
                                  </td>
                                  <td>
                                    <button
                                      v-if="dataPolizaVida"
                                      type="button"
                                      class="btn btn-warning"
                                      @click="
                                        deletePolizaVida(data.certificadoVida)
                                      "
                                    >
                                      Cancelar
                                    </button>
                                  </td>
                                  <td>
                                    <button
                                      v-if="dataPolizaVida"
                                      type="button"
                                      class="btn btn-danger"
                                      @click="
                                        deletePolizaVida(data.certificadoVida)
                                      "
                                    >
                                      Eliminar
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>
        <!--INICIO MODAL EDITAR cancelacion-->
        <b-modal
          v-model="modalEstatus"
          id="edit"
          size="lg"
          title="Nueva Compañia"
          centered
        >
          <div class="col-sm-12">
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm-6">
                      <label class="control-label">Cambiar Estatus</label>
                      <multiselect
                        v-model="dataEstatus.estatus"
                        :show-labels="false"
                        :options="estatusOptions"
                      ></multiselect>
                    </div>
                  </div>
                  <br />
                  <div class="row">
                    <div class="col-sm-12">
                      <label class="control-label">Comentarios</label>
                      <textarea
                        id="message"
                        v-model="dataEstatus.descripCancelacion"
                        class="form-control"
                      ></textarea>
                    </div>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
          <template v-slot:modal-footer>
            <button @click="Estatus" type="button" class="btn btn-success">
              Guardar
            </button>
            <b-button variant="secondary" @click="modalEstatus = false"
              >Cerrar</b-button
            >
          </template>
        </b-modal>
        <!--FIN MODAL EDITAR cancelacion-->
      </b-tabs>
    </div>

    <!-- end row -->
  </Layout>
</template>
